export const ProductSelectorType = {
  GRID: 'GRID',
  SWATCH: 'SWATCH',
  DEFAULT: 'DEFAULT',
};
